import { useTranslation } from 'next-i18next'
import { getStaticPaths, makeStaticProps } from 'lib/getStatic'
import MainLayout from 'components/layouts/MainLayout'
import SeoHead from '@/components/seo/SeoHead'

export default function PageDatenschutz() {
  const { t } = useTranslation('privacy')

  return (
    <>
      <SeoHead
        title={t('title')}
        description={t('description')}
        dePath="datenschutz"
        enPath="privacy"
      />

      <main style={{ fontFamily: 'Verdana, sans-serif' }}>
        <MainLayout view="privacy" />
      </main>
    </>
  )
}

const getStaticProps = makeStaticProps(['common', 'privacy'])
export { getStaticPaths, getStaticProps }
